module.exports = __webpack_public_path__ + "media/images/icons/fb-309da0ddc2a24622ec4d17bdf639c356.svg";